import { isValidUrl } from "utils/urlUtils";
import { SDEContent } from "./sdecontentTypes";

export const LlmUrls: SDEContent = {
  projectType: 'async_urls_llm',
  projectCategory: 'async_urls_llm',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/`;
  },
  docsSection: '',
  docsSectionTitle: '',
  docsSectionAsync: '',
  docsSectionAsyncTitle: '',
  inputKey: 'url',
  inputsKey: 'urls',
  validatorFunction: isValidUrl,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'URLs',
      listLiteralInputPlaceholder: 'Enter one URL per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input URLs',
      inputSectionDescription: "Enter URLs or upload a file",
    },
    projectContent: {
      title: 'LLM-ready data',
      description: 'Get your data in LLM-ready format like text and markdown, to effectively train LLMs on a large scale.',
      icon: 'fire',
      inputTitle: 'URL',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input URL address',
      inputSectionDescription: 'Enter the URL you want to scrape. The URL must be correctly encoded, like https://httpbin.org/json',
    },
    projectContent: {
      title: 'LLM-ready data',
      description: 'Get your data in LLM-ready format like text and markdown, to effectively train LLMs on a large scale.',
      icon: 'fire',
    },
    enterInputsPlaceholder: 'https://httpbin.org/json',
    enterInputsMessage: 'Enter URL addresses for scraping',
    codeViewPlaceHolder: 'Please provide a valid URL',
    dropdownTitle: ''
  }
};
